module.exports = __webpack_public_path__ + "img/mail.6a250299.svg";